import type { SVGProps } from "react";
export default function SvgLink(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-link2-icon lucide-link-2"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M9 17H7A5 5 0 0 1 7 7h2" />
			<path d="M15 7h2a5 5 0 1 1 0 10h-2" />
			<line x1={8} x2={16} y1={12} y2={12} />
		</svg>
	);
}
